<template>
  <tr v-if="flow.authorizationUrl" data-cy="authorizationUrl">
    <td>
      {{ $t(`documentation.api.auth.oauth2.authorizationUrl`) }}
    </td>
    <td><ApiSecurityOAuth2FlowUrl :url="flow.authorizationUrl" /></td>
  </tr>

  <tr v-if="flow.tokenUrl" data-cy="tokenUrl">
    <td>
      {{ $t(`documentation.api.auth.oauth2.tokenUrl`) }}
    </td>
    <td><ApiSecurityOAuth2FlowUrl :url="flow.tokenUrl" /></td>
  </tr>

  <tr v-if="flow.refreshUrl" data-cy="refreshUrl">
    <td>
      {{ $t(`documentation.api.auth.oauth2.refreshUrl`) }}
    </td>
    <td><ApiSecurityOAuth2FlowUrl :url="flow.refreshUrl" /></td>
  </tr>

  <tr v-if="scopes.length > 0" data-cy="scopes">
    <td colspan="2">
      {{ $t('pages.documentation.api.security.scopes') }}:
      <ul>
        <li v-for="[key, value] in scopes" :key="key">
          <code>{{ key }}</code> - {{ value }}
        </li>
      </ul>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { OpenAPIV3 } from 'openapi-types';
import ApiSecurityOAuth2FlowUrl from '@/components/api/content/operations/security/ApiSecurityOAuth2FlowUrl.vue';

type Data =
  | OpenAPIV3.OAuth2SecurityScheme['flows']['clientCredentials']
  | OpenAPIV3.OAuth2SecurityScheme['flows']['authorizationCode'];

const props = defineProps({
  flow: { type: Object as PropType<Data>, required: true },
});

const scopes = computed(() => Object.entries(props.flow.scopes));
</script>

<style scoped lang="scss">
ul {
  padding-top: 5px;
}
</style>
